import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {ELEMENT_NAME_MAX, ELEMENT_NAME_MIN} from './constant';

export const modalValidator = z.object({
    type: z.literal(ELEMENT.MODAL),
    title: z.string().min(ELEMENT_NAME_MIN, `title;min;${ELEMENT_NAME_MIN}`).max(ELEMENT_NAME_MAX, `title;max;${ELEMENT_NAME_MAX}`),
    selectedSlideId: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.modalElement.validation.selectedSlideId',
    }),
    elementToClickForDisplay: z.array(z.string()).min(1, {
        message: 'presEditPage.editSidebar.elements.modalElement.validation.elementToClickForDisplay',
    }),
});
